export interface GetShareDto {
    id: string;
    fromOrganizationName: string;
}
